/**
 * estimate.js v7 — printbrain.jp リアルタイム見積もり
 * コミコミ商品（price_type=allin）対応
 * ナイロン素材（print_type=nylon）対応
 */

(function () {
  'use strict';

  const SEIHAN = { a3_under: 8800, a3_over: 11000 };
  const PRINT = {
    1: { fixed: 5500,  lots: [{ min: 10, price: 330 }, { min: 30, price: 275 }, { min: 50, price: 220 }] },
    2: { fixed: 6600,  lots: [{ min: 10, price: 385 }, { min: 30, price: 330 }, { min: 50, price: 275 }] },
    3: { fixed: 7700,  lots: [{ min: 10, price: 495 }, { min: 30, price: 440 }, { min: 50, price: 330 }] },
    4: { fixed: 8800,  lots: [{ min: 10, price: 660 }, { min: 30, price: 605 }, { min: 50, price: 495 }] },
    5: { fixed: 9900,  lots: [{ min: 10, price: 770 }, { min: 30, price: 715 }, { min: 50, price: 605 }] },
  };
  // ナイロン素材専用プリント単価（1色・A3以下固定・10枚〜）
  const PRINT_NYLON = [
    { min: 10, price: 1300 },
    { min: 20, price: 1150 },
    { min: 40, price: 1000 },
    { min: 80, price:  900 },
  ];
  const TAX_RATE = 0.10;
  const MAX_LOCATIONS = 5;

  let locations = [{ size: 'a3_under', colors: 1 }];

  // ============================================================
  // price_type / print_type の取得
  // ============================================================

  function isAllin() {
    const el = document.getElementById('pb-price-type');
    return el ? el.dataset.priceType === 'allin' : false;
  }

  function isNylon() {
    const el = document.getElementById('pb-print-type');
    return el ? el.dataset.printType === 'nylon' : false;
  }

  function getQtyRange() {
    const el = document.getElementById('pb-qty-range');
    if (!el) return { min: null, max: null };
    const min = el.dataset.minQty ? parseInt(el.dataset.minQty, 10) : null;
    const max = el.dataset.maxQty ? parseInt(el.dataset.maxQty, 10) : null;
    return { min, max };
  }

  function isOutOfRange(qty) {
    const { min, max } = getQtyRange();
    if (min !== null && qty < min) return { out: true, min, max };
    if (max !== null && qty > max) return { out: true, min, max };
    return { out: false, min, max };
  }

  // ============================================================
  // 箇所の状態管理
  // ============================================================

  function setLocationSize(index, size) {
    if (!locations[index]) return;
    locations[index].size = size;
    updateLocationSizeButtons(index);
    recalculate();
  }

  function setLocationColors(index, colors) {
    if (!locations[index]) return;
    locations[index].colors = colors;
    updateLocationColorButtons(index);
    recalculate();
  }

  function addLocation() {
    if (locations.length >= MAX_LOCATIONS) return;
    locations.push({ size: 'a3_under', colors: 1 });
    renderLocations();
    recalculate();
  }

  function removeLocation(index) {
    if (locations.length <= 1) return;
    locations.splice(index, 1);
    renderLocations();
    recalculate();
  }

  // ============================================================
  // 計算ロジック
  // ============================================================

  function calcPrintCostPerLocation(qty, colors) {
    if (isNylon()) {
      // ナイロン：10枚未満は受け付けない（min_qtyで制御）
      let unit = PRINT_NYLON[0].price;
      for (const lot of PRINT_NYLON) { if (qty >= lot.min) unit = lot.price; }
      return unit * qty;
    }
    const row = PRINT[colors] || PRINT[1];
    if (qty < 10) return row.fixed;
    let unit = row.lots[0].price;
    for (const lot of row.lots) { if (qty >= lot.min) unit = lot.price; }
    return unit * qty;
  }

  function calculate({ qty, garmentUnitPrice }) {
    if (!qty || qty < 1 || !garmentUnitPrice) return null;

    const garmentTotal = garmentUnitPrice * qty;
    let seihanTotal = 0;
    let printTotal  = 0;
    const locationDetails = [];

    // コミコミの場合は製版代・プリント代を計算しない
    if (!isAllin()) {
      if (isNylon()) {
        // ナイロン：1色・A3以下・1箇所固定
        const seihanForLoc = SEIHAN.a3_under * 1;
        const printForLoc  = calcPrintCostPerLocation(qty, 1);
        seihanTotal = seihanForLoc;
        printTotal  = printForLoc;
        locationDetails.push({ size: 'a3_under', colors: 1, seihanForLoc, printForLoc });
      } else {
        locations.forEach(function(loc) {
          const colors       = loc.colors || 1;
          const size         = loc.size   || 'a3_under';
          const seihanUnit   = SEIHAN[size] || SEIHAN.a3_under;
          const seihanForLoc = seihanUnit * colors;
          const printForLoc  = calcPrintCostPerLocation(qty, colors);
          seihanTotal += seihanForLoc;
          printTotal  += printForLoc;
          locationDetails.push({ size, colors, seihanForLoc, printForLoc });
        });
      }
    }

    const subtotal  = garmentTotal + seihanTotal + printTotal;
    const tax       = Math.round(subtotal * TAX_RATE);
    const total     = subtotal + tax;
    const unitPrice = Math.ceil(total / qty);

    return {
      garmentTotal, seihanTotal, printTotal,
      subtotal, tax, total, unitPrice,
      qty, locationDetails,
      locationCount: isNylon() ? 1 : locations.length,
    };
  }

  // ============================================================
  // DOM更新
  // ============================================================

  function yen(n) { return '¥' + Math.round(n).toLocaleString('ja-JP'); }

  function updateWidget(result) {
    const widget = document.getElementById('pb-estimate-widget');
    if (!widget) return;
    if (!result) { widget.style.display = 'none'; return; }

    widget.style.display = 'block';
    widget.classList.remove('pb-updated');
    void widget.offsetWidth;
    widget.classList.add('pb-updated');

    const set = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };

    // 枚数範囲チェック
    const rangeCheck = isOutOfRange(result.qty);
    const warning = document.getElementById('pb-qty-warning');
    const body    = document.getElementById('pb-widget-body');

    if (rangeCheck.out) {
      // 範囲外：警告を表示してウィジェット本体を隠す
      const minStr = rangeCheck.min !== null ? rangeCheck.min + '枚' : '';
      const maxStr = rangeCheck.max !== null ? rangeCheck.max + '枚' : '';
      const rangeStr = (minStr && maxStr) ? minStr + '〜' + maxStr
                     : minStr ? minStr + '以上'
                     : maxStr ? maxStr + '以下' : '';
      if (warning) {
        warning.textContent = 'このプランは' + rangeStr + 'でご利用いただけます（現在：' + result.qty + '枚）';
        warning.style.display = 'block';
      }
      if (body) body.style.display = 'none';
      return;
    } else {
      // 範囲内：警告を隠してウィジェット本体を表示
      if (warning) warning.style.display = 'none';
      if (body) body.style.display = 'block';
    }

    set('pb-total',        yen(result.total));
    set('pb-unit-price',   yen(result.unitPrice) + ' / 枚');
    set('pb-garment-cost', yen(result.garmentTotal));

    // コミコミ時は製版代・プリント代の行を非表示
    const seihanRow = document.getElementById('pb-seihan-cost');
    const printRow  = document.getElementById('pb-print-cost');
    const allin = isAllin();

    if (seihanRow) {
      const row = seihanRow.closest('.pb-row');
      if (row) row.style.display = allin ? 'none' : '';
    }
    if (printRow) {
      const row = printRow.closest('.pb-row');
      if (row) row.style.display = allin ? 'none' : '';
    }

    if (!allin) {
      // 製版代の内訳
      if (result.locationCount === 1) {
        const d = result.locationDetails[0];
        const sizeLabel = d.size === 'a3_over' ? 'A3以上' : 'A3以下';
        set('pb-seihan-cost',
          d.colors === 1
            ? yen(result.seihanTotal) + '（' + sizeLabel + '）'
            : yen(SEIHAN[d.size] || SEIHAN.a3_under) + ' × ' + d.colors + '色（' + sizeLabel + '） = ' + yen(result.seihanTotal)
        );
      } else {
        const detail = result.locationDetails.map(function(d, i) {
          const sizeLabel = d.size === 'a3_over' ? 'A3以上' : 'A3以下';
          return '箇所' + (i + 1) + ':' + yen(d.seihanForLoc) + '（' + d.colors + '色/' + sizeLabel + '）';
        }).join('  ');
        set('pb-seihan-cost', yen(result.seihanTotal) + '\n' + detail);
      }

      // プリント代の内訳
      if (result.locationCount === 1) {
        const d = result.locationDetails[0];
        if (isNylon()) {
          set('pb-print-cost', yen(result.printTotal) + '（1色・A3以下）');
        } else {
          set('pb-print-cost',
            d.colors === 1
              ? yen(result.printTotal)
              : yen(result.printTotal) + '（' + d.colors + '色）'
          );
        }
      } else {
        const detail = result.locationDetails.map(function(d, i) {
          return '箇所' + (i + 1) + ':' + yen(d.printForLoc);
        }).join('  ');
        set('pb-print-cost', yen(result.printTotal) + '\n' + detail);
      }
    }

    set('pb-tax', yen(result.tax));
  }

  // ============================================================
  // プリント箇所UIの描画
  // ============================================================

  function renderLocations() {
    const root = document.getElementById('pb-print-locations-root');
    if (!root) return;
    root.innerHTML = '';

    // ナイロン：固定表示（ボタン選択なし）
    if (isNylon()) {
      const block = document.createElement('div');
      block.className = 'pb-location-block';

      const header = document.createElement('div');
      header.className = 'pb-location-header';
      const title = document.createElement('span');
      title.className = 'pb-location-title';
      title.textContent = 'プリント箇所 1';
      header.appendChild(title);
      block.appendChild(header);

      const fixedNote = document.createElement('div');
      fixedNote.style.cssText = 'font-size:1.2rem; color:rgba(var(--color-foreground),0.55); padding:0.4rem 0;';
      fixedNote.textContent = '1色・A3以下（30cm×30cm）固定';
      block.appendChild(fixedNote);

      root.appendChild(block);
      return;
    }

    locations.forEach(function(loc, i) {
      const block = document.createElement('div');
      block.className = 'pb-location-block';
      block.dataset.locationIndex = i;

      const header = document.createElement('div');
      header.className = 'pb-location-header';
      const title = document.createElement('span');
      title.className = 'pb-location-title';
      title.textContent = 'プリント箇所 ' + (i + 1);
      header.appendChild(title);

      if (locations.length > 1) {
        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'pb-location-remove';
        removeBtn.textContent = '削除';
        removeBtn.addEventListener('click', function() { removeLocation(i); });
        header.appendChild(removeBtn);
      }
      block.appendChild(header);

      // 色数選択
      const colorsLabel = document.createElement('div');
      colorsLabel.className = 'pb-loc-label';
      colorsLabel.textContent = 'デザインの色数';
      block.appendChild(colorsLabel);

      const colorsButtons = document.createElement('div');
      colorsButtons.className = 'pb-loc-buttons';
      colorsButtons.dataset.locationIndex = i;
      colorsButtons.dataset.type = 'colors';

      [1, 2, 3, 4, 5].forEach(function(c) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pb-loc-btn' + (loc.colors === c ? ' pb-loc-btn--active' : '');
        btn.dataset.colors = c;
        btn.textContent = c + '色';
        btn.addEventListener('click', function() { setLocationColors(i, c); });
        colorsButtons.appendChild(btn);
      });
      block.appendChild(colorsButtons);

      // デザインサイズ選択
      const sizeLabel = document.createElement('div');
      sizeLabel.className = 'pb-loc-label';
      sizeLabel.textContent = 'デザインサイズ';
      block.appendChild(sizeLabel);

      const sizeButtons = document.createElement('div');
      sizeButtons.className = 'pb-loc-buttons';
      sizeButtons.dataset.locationIndex = i;
      sizeButtons.dataset.type = 'size';

      [{ value: 'a3_under', label: 'A3以下' }, { value: 'a3_over', label: 'A3以上' }].forEach(function(opt) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pb-loc-btn' + (loc.size === opt.value ? ' pb-loc-btn--active' : '');
        btn.dataset.size = opt.value;
        btn.textContent = opt.label;
        btn.addEventListener('click', function() { setLocationSize(i, opt.value); });
        sizeButtons.appendChild(btn);
      });
      block.appendChild(sizeButtons);

      root.appendChild(block);
    });

    // 箇所追加ボタン
    const addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'pb-add-location';
    addBtn.disabled = locations.length >= MAX_LOCATIONS;
    addBtn.innerHTML = '<span style="font-size:1.6rem;line-height:1;margin-right:0.3rem">+</span>プリント箇所を追加（最大' + MAX_LOCATIONS + '箇所）';
    addBtn.addEventListener('click', addLocation);
    root.appendChild(addBtn);
  }

  function updateLocationSizeButtons(index) {
    const container = document.querySelector('.pb-loc-buttons[data-location-index="' + index + '"][data-type="size"]');
    if (!container) return;
    container.querySelectorAll('.pb-loc-btn').forEach(function(btn) {
      btn.classList.toggle('pb-loc-btn--active', btn.dataset.size === locations[index].size);
    });
  }

  function updateLocationColorButtons(index) {
    const container = document.querySelector('.pb-loc-buttons[data-location-index="' + index + '"][data-type="colors"]');
    if (!container) return;
    container.querySelectorAll('.pb-loc-btn').forEach(function(btn) {
      btn.classList.toggle('pb-loc-btn--active', parseInt(btn.dataset.colors) === locations[index].colors);
    });
  }

  // ============================================================
  // 入力値の収集・初期化
  // ============================================================

  function getQty() {
    const qtyInput = document.querySelector([
      '.quantity__input', 'input[name="quantity"]', '#Quantity',
      'quantity-input input', '.product-form__quantity input', '[data-quantity-input]',
    ].join(', '));
    return qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
  }

  function collectParams() {
    const priceEl = document.querySelector('[data-pb-garment-price]');
    return {
      qty: getQty(),
      garmentUnitPrice: priceEl ? parseInt(priceEl.dataset.pbGarmentPrice, 10) : 0,
    };
  }

  function recalculate() {
    updateWidget(calculate(collectParams()));
  }

  function init() {
    if (!document.getElementById('pb-estimate-widget')) return;

    // コミコミの場合はプリント箇所UIを描画しない
    if (!isAllin()) {
      renderLocations();
    }

    document.addEventListener('variant:change', recalculate);

    const QTY_SELECTOR = [
      '.quantity__input', 'input[name="quantity"]', '#Quantity',
      'quantity-input input', '.product-form__quantity input', '[data-quantity-input]',
    ].join(', ');
    document.addEventListener('input',  function(e) { if (e.target.matches(QTY_SELECTOR)) recalculate(); });
    document.addEventListener('change', function(e) { if (e.target.matches(QTY_SELECTOR)) recalculate(); });
    document.addEventListener('quantity:changed', recalculate);

    recalculate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
